import bambuearth from '@/assets/brands/bambuearth.avif?inline';
import carryProof from '@/assets/brands/carry-proof.avif?inline';
import ellaola from '@/assets/brands/ellaola.avif?inline';
import joahBrown from '@/assets/brands/joah-brown.avif?inline';
import obvi from '@/assets/brands/obvi.avif?inline';
import saintAndSofia from '@/assets/brands/saint-and-sofia.avif?inline';
import type { FeaturedBrandLogo } from '../types/featured-customer-logos-types';
export const featuredCustomerLogos: readonly FeaturedBrandLogo[] = Object.freeze([

  { src: obvi, alt: 'Obvi' },
  { src: bambuearth, alt: 'Bambu Earth' },
  { src: ellaola, alt: 'Ella Ola' },
  { src: saintAndSofia, alt: 'Saint & Sofia' },
  { src: carryProof, alt: 'Carry Proof' },
  { src: joahBrown, alt: 'Joah Brown' },
]);

